import VerticalMenuItem from './VerticalMenuItem'

export default VerticalMenuItem
